import { ConsultationStatus } from './ConsultationStatus.js';
import {
  mapDtoList,
  optionalEnum,
  optionalString,
  requireNumber,
  requireObject,
  requireString,
} from './parse.js';

const TYPE_NAME = 'ConsultationListData';

/**
 * Mirrors com.medprompt.consultation.ConsultationListData, the row shape of every consultations list.
 *
 * @typedef {object} ConsultationListData
 * @property {string} consultationId
 * @property {string|null} nhsId
 * @property {string|null} patientId
 * @property {string|null} userId
 * @property {number} timestamp
 * @property {string|null} status
 */

/**
 * @param {object} raw
 * @returns {ConsultationListData}
 */
export function fromConsultationListData(raw) {
  const source = requireObject(raw, TYPE_NAME);
  return {
    consultationId: requireString(source, 'consultationId', TYPE_NAME),
    nhsId: optionalString(source.nhsId),
    patientId: optionalString(source.patientId),
    userId: optionalString(source.userId),
    timestamp: requireNumber(source, 'timestamp', TYPE_NAME),
    status: optionalEnum(source.status, ConsultationStatus, TYPE_NAME, 'status'),
  };
}

/**
 * @param {unknown} raw
 * @returns {ConsultationListData[]}
 */
export function fromConsultationListDataList(raw) {
  return mapDtoList(raw, TYPE_NAME, fromConsultationListData);
}
